import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChangeoverRepositoryService extends BaseRepositoryService<
  ModelRegistry['changeover']
> {
  recordName = 'changeover';
  implementMethods = ['findRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/changeover': ChangeoverRepositoryService;
  }
}
